/* @ngInject */
export default class SiteService {
  #$sails;

  #$q;
  constructor($q, $sails) {
    this.#$sails = $sails;

    this.#$q = $q;
  }


  /**
   * @param {string} [id=''] If unsupplied, retrieves all sites
   * @returns {object | Array<object>}
   * @memberof SiteService
   */
  get(id = '') {
    return this.tryFetch(() => this.#$sails.get(`/site/${id}`));
  }

  create(newSite) {
    return this.tryFetch(() => this.#$sails.post('/site', newSite));
  }

  update(siteId, newSite) {
    return this.tryFetch(() => this.#$sails.put(`/site/${siteId}`, newSite));
  }

  destroy(siteId) {
    return this.tryFetch(() => this.#$sails.delete(`/site/${siteId}`));
  }


  async tryFetch(fetch) {
    try {
      const { data } = await fetch();
      return data;
    } catch (error) {
      console.error(error);
      return this.#$q.reject(error.data);
    }
  }
}
